import React from 'react';
// import data
import { nav, header } from '../data';
import { Link } from 'react-router-dom';



const MobileNav = () => {
  const { btnText, logo } = header;
  return (
    <div className='bg-white w-[300px] h-full'>
      <Link to='/' data-aos='fade-down' data-aos-delay='1000'>
          <img src={logo} alt='tdp-logo' className='w-[100px] h-[100px] mx-auto animate-wiggle' />
        </Link>
      <ul className='h-[500px] flex  flex-col justify-center items-center gap-y-8'>
        {nav.map((item, index) => {
          // destructure item
          const { href, name } = item;
          return (
            <li key={index}>
              <Link className='link text-black text-xl hover:underline hover:text-sky-200' to={href}>
                {name}
              </Link>


            </li>

          );
        })}
        <div>
          <Link className='link text-black text-xl hover:underline hover:text-sky-200' to='/login' > {btnText}</Link>
        </div>
      </ul>


    </div >
  );
};

export default MobileNav;
